// @flow
import React from 'react';

import { AuthAsideBase } from 'pages/authPage/Layout/StyledComponents';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';

import { styled, useTheme } from '@mui/material/styles';

const AuthAside = styled(AuthAsideBase)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
}));

const AuthAsideAlprime = () => {
  const {
    labelOptions: { loginNameImg, loginPoweredBy, loginSlogan, logo },
  } = useTheme();

  return (
    <AuthAside>
      <Box m="auto" width="300px" sx={{ textAlign: 'center' }}>
        <img src={logo.src} alt={logo.alt} />
        <br />
        <br />
        <img src={loginNameImg.src} alt={loginNameImg.alt} width="100%" />
        {loginSlogan && (
          <Typography mt={1} color="common.white" sx={{ textTransform: 'uppercase', textAlign: 'center' }}>
            {loginSlogan}
          </Typography>
        )}
      </Box>
      {loginPoweredBy && (
        <Box mx="auto" mb={1}>
          <Link href="https://www.dokka.com" target="blank" sx={{ color: 'common.white' }}>
            Powered by DOKKA
          </Link>
        </Box>
      )}
    </AuthAside>
  );
};

export default AuthAsideAlprime;
